import { HTTP } from "@/helpers/http-common"

const url = "/api/correo"

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default { list }



// WEBPACK FOOTER //
// ./src/services/bitacoras/correo/index.js